import { render, staticRenderFns } from "./BeneficiariesFilter.vue?vue&type=template&id=8c336dbc&"
import script from "./BeneficiariesFilter.vue?vue&type=script&lang=js&"
export * from "./BeneficiariesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports